import React from 'react'
import {productListInformation} from '@data/fragments/products/__generated__/productListInformation'
import selectPriceForProduct from '@helpers/misc/selectPriceForProduct'
import FormatNumber from '@i18n/formatNumber/Component'
import PRICING_TYPES from '@page-components/Order/CategoryPage/Content/Products/ProductCard/pricingTypes'

export interface Props {
  product: productListInformation
}

export default function ProductPrice(props: Props) {
  const pricing = selectPriceForProduct(props.product)
  return (
    pricing && (
      <div className="flex flex-row gap-x-2 text-sm">
        {[PRICING_TYPES.normal, PRICING_TYPES.discount].includes(pricing.type as PRICING_TYPES) && (
          <div className="text-black">
            <FormatNumber value={pricing.price} />
          </div>
        )}
        {pricing.type === PRICING_TYPES.discount && (
          <div className="text-gray-400 line-through">
            <FormatNumber value={pricing.oldPrice} />
          </div>
        )}
      </div>
    )
  )
}
